export const DASHBOARD_NOTICES = [
  '공지를 등록해보세요! 공지를 등록하면 평균적으로 20% 이상의 매출 상승 효과가 있습니다.',
  '오늘의 추천 메뉴를 골라두면 주방도, 손님도 덜 헤맵니다.',
  '이벤트 홍보는 공지 한 줄이면 충분해요.',
  '피크타임 직전 30분이 이벤트를 알리기 가장 좋은 순간입니다.',
  '품절 메뉴를 미리 체크해두면 손님 대기 시간이 절반으로 줄어듭니다.',
  '매출 추이를 매일 살펴보는 습관만으로도 의사결정이 빨라집니다.',
  '오늘도 고생 많으셨어요. 대시보드 한 번 훑어보고 가세요.',
];
